module.exports = __webpack_public_path__ + "assets/media/autumn-night.b960c1bf.ogg";